import React, { useCallback, useState } from 'react';

import Button, { BUTTON_TYPES } from '@buyside/components/presentation/Button/button';
import Link from '@buyside/components/presentation/Link/link';
import Modal from '@buyside/components/presentation/Modal/modal';

import { quickPositionsPageUrl } from '@buyside/util/urlHelper';

import styles from './openQuickPositionFormStyles.scss';

const QuickPositionDescriptionModal: React.FC = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const renderOpenModalButton = useCallback(
    () => (
      <Button
        buttonType={BUTTON_TYPES.BUTTON}
        className={styles.descriptionButton}
        onClick={() => setIsModalOpen(true)}
        text="quick position"
        type={BUTTON_TYPES.LINK}
      />
    ),
    []
  );

  return (
    <Modal
      isOpen={isModalOpen}
      onClose={() => setIsModalOpen(false)}
      renderOpenModalButton={renderOpenModalButton}
      size="lg"
      title="About Quick Positions"
    >
      <div>
        <p>
          Build your position portfolio and track the return performance through{' '}
          <Link to={quickPositionsPageUrl()} target="_blank">
            your quick positions dashboard
          </Link>
          .
        </p>
        <p>
          Once you take a position, you will be able to see the community sentiment on the security
          and join the conversation with other members who have interest in it.
        </p>
        <p>
          More interactive features are being developed, such as leaderboards, to further increase
          your presence on Sumzero.
        </p>
      </div>
    </Modal>
  );
};

export default QuickPositionDescriptionModal;
